import React from 'react';
import '../estilo.css';

export default class Inicio extends React.Component {
  render() {
    return (
      <div>
        {/* HERO / TOPO */}
        <div className="jumbotron text-center">
          <span>
            <img
              src={require('../img/Quantum1.png')}
              alt="Quantum Trades EA"
              className="responsive-image"
              style={{ maxWidth: '320px', height: 'auto' }}
            />
          </span>
          <h1>Quantum Trades EA</h1>
          <h3>Automação inteligente para Forex no MetaTrader 5</h3>

          <p>
            Um robô profissional que combina <strong>indicadores avançados</strong>,{' '}
            <strong>correlação entre ativos</strong> e{' '}
            <strong>gestão inteligente de posição</strong> para potencializar seus resultados.
          </p>

          <p style={{ marginTop: 10, fontSize: 15 }}>
            <strong>Licença acessível</strong>, pensada para caber no bolso de quem está construindo
            capital — sem promessas milagrosas, apenas tecnologia e disciplina a seu favor.
          </p>

          <div style={{ marginTop: '20px' }}>
            <a
              href="/cadastro"
              className="btn btn-primary btn-lg"
              style={{ marginRight: '10px' }}
            >
              Quero começar com o EA
            </a>
            <a href="#portfolio" className="btn btn-default btn-lg">
              Ver resultados do portfólio
            </a>
          </div>
        </div>

        {/* SEÇÃO SOBRE / ID PARA O MENU */}
        <div id="about" className="container-fluid bg-quant">
          <div className="row">
            {/* Coluna texto principal */}
            <div className="col-sm-7">
              <h2>O que é o Quantum Trades EA?</h2>
              <p>
                O <strong>Quantum Trades EA</strong> é um robô para MetaTrader 5 (MT5) desenvolvido
                para operar de forma <strong>automatizada</strong> em contas{' '}
                <strong>USC (Cent)</strong> ou contas padrão. Ele monitora múltiplos pares,
                analisa o comportamento do preço em tempo real e executa entradas, reentradas e
                realizações parciais de forma totalmente programada.
              </p>
              <p>
                Você pode utilizar nossos <strong>portfólios prontos</strong>, já testados em
                contas de <strong>US$ 150</strong>, <strong>US$ 300</strong>,{' '}
                <strong>US$ 600</strong> (e equivalentes em USC), ou montar as suas próprias
                estratégias com dezenas de parâmetros ajustáveis.
              </p>

              {/* NOVA SESSÃO: MISSÃO / PROPÓSITO */}
              <h3>Nossa missão: ajudar você a construir capital e realizar seus planos</h3>
              <p>
                A Quantum Trades nasceu com uma ideia simples: <strong>tornar a automação acessível</strong>.
                Nosso foco não é “vender robô caro”, e sim oferecer uma ferramenta que ajude o trader
                a <strong>organizar a rotina de operações</strong>, buscar consistência e construir, pouco a pouco,
                o capital que pode viabilizar projetos de vida, sonhos pessoais ou mesmo a sua
                aposentadoria no longo prazo.
              </p>
              <p>
                Por isso, mantemos o robô com um <strong>valor acessível</strong> e transparentemente
                definido, para que você possa investir a maior parte do seu dinheiro onde realmente
                importa: <strong>no seu capital de trade</strong>, e não em mensalidades abusivas.
              </p>

              <h3>Por que escolher a Quantum Trades?</h3>
              <ul>
                <li>
                  <strong>Preço acessível e transparente:</strong> o foco é viabilizar o uso da
                  automação para o maior número de traders possível, sem taxas escondidas.
                </li>
                <li>
                  <strong>Filosofia de parceria, não de venda:</strong> queremos construir
                  relacionamento de longo prazo. Quanto mais tempo você se mantém operando com
                  responsabilidade, melhor para você e para nós.
                </li>
                <li>
                  <strong>Foco em ajudar o trader, não em prometer riqueza:</strong> não vendemos
                  ilusão de dinheiro fácil. O robô é uma ferramenta para apoiar sua disciplina e
                  estratégia, sempre com lembrança clara dos riscos do mercado.
                </li>
                <li>
                  <strong>Você continua no controle:</strong> o EA opera na sua conta, com o capital
                  que você define, usando as configurações que fazem sentido para o seu perfil de
                  risco.
                </li>
                <li>
                  <strong>Portfólios prontos + liberdade total:</strong> use configurações prontas
                  para começar mais rápido ou monte suas próprias estratégias, com dezenas de filtros
                  e opções de gestão de risco.
                </li>
                <li>
                  <strong>Comunidade e suporte próximos:</strong> canais de contato via
                  <strong> WhatsApp</strong>, <strong>Telegram</strong> e e-mail para tirar dúvidas
                  sobre instalação, uso e boas práticas de configuração.
                </li>
              </ul>

              <h3>O que torna o Quantum Trades EA diferente na prática?</h3>
              <ul>
                <li>
                  <strong>OpenBox:</strong> total transparência e liberdade para criar suas
                  próprias estratégias ou usar as nossas.
                </li>
                <li>
                  <strong>Correlação entre ativos:</strong> o robô consegue analisar relações
                  entre diferentes pares, ajudando a evitar operações conflitantes e contribuindo
                  para uma diversificação mais inteligente.
                </li>
                <li>
                  <strong>Reentradas e realizações parciais inteligentes:</strong> qualquer
                  reentrada pode usar indicadores específicos, e você define o tamanho de cada
                  RP (realização parcial).
                </li>
                <li>
                  <strong>Gestão de risco avançada:</strong> break-even, trailing stop,
                  limites de exposição e filtros de horário/notícias (conforme a configuração).
                </li>
                <li>
                  <strong>Portfólio validado em backtests:</strong> estratégias rodando e sendo
                  ajustadas há mais de 1 ano.
                </li>
              </ul>

              <p>
                Em resumo: usamos tecnologia para que você tenha mais{" "}
                <strong>processo e disciplina</strong> nos trades, sabendo sempre que o mercado
                envolve risco e que ninguém pode garantir resultados futuros.
              </p>
            </div>

            {/* Coluna imagens / apoio visual */}
            <div className="col-sm-5 text-center">
              <div style={{ marginBottom: '20px' }}>
                <img
                  src={require('../img/Quantum2.png')}
                  alt="Quantum Trades EA Interface"
                  className="responsive-image"
                  style={{ maxWidth: '320px', height: 'auto' }}
                />
              </div>
              <div>
                <img
                  src={require('../img/MetaTrader5.png')}
                  alt="MetaTrader 5"
                  className="responsive-image"
                  style={{ maxWidth: '280px', height: 'auto', marginTop: '10px' }}
                />
                <p style={{ marginTop: '10px' }}>
                  Compatível com plataformas que utilizam o <strong>MetaTrader 5</strong>.
                </p>
              </div>
            </div>
          </div>

          {/* Chamada final da seção */}
          <div className="row" style={{ marginTop: '30px' }}>
            <div className="col-sm-12 text-center">
              <h3>Comece com pouco capital e evolua junto com o seu portfólio</h3>
              <p>
                Já temos configurações prontas para contas a partir de{' '}
                <strong>US$ 150 (15.000 USC)</strong>, sempre lembrando que resultados de hoje
                não garantem resultados futuros e que configurações incorretas podem gerar
                prejuízos.
              </p>
              <p>
                O primeiro passo não é “ficar rico da noite para o dia”, e sim{' '}
                <strong>operar com consciência, controle e visão de longo prazo</strong>. Se isso
                faz sentido para você, a Quantum Trades pode ser sua parceira nessa jornada.
              </p>
              <a href="/cadastro" className="btn btn-primary btn-lg">
                Criar minha conta e começar
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
